import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { ResourceState } from '../types';
import { initialResourceState } from './resourceState';

export const resourceSlice = createSlice({
  name: 'resource',
  initialState: initialResourceState,
  reducers: {
    setLimit: (state, action: PayloadAction<ResourceState['limit']>) => {
      state.limit = action.payload;
    },
    setPageIndex: (
      state,
      action: PayloadAction<ResourceState['pageIndex']>,
    ) => {
      state.pageIndex = action.payload;
    },
    setTotalRecordCount: (
      state,
      action: PayloadAction<ResourceState['totalRecordCount']>,
    ) => {
      state.totalRecordCount = action.payload;
    },
  },
});

export const { actions: resourceActions } = resourceSlice;

const selectResource = (state: RootState) => state.resource;

export const selectLimit = createSelector(
  selectResource,
  resource => resource.limit,
);
export const selectPageIndex = createSelector(
  selectResource,
  resource => resource.pageIndex,
);
export const selectTotalRecordCount = createSelector(
  selectResource,
  resource => resource.totalRecordCount,
);

export default resourceSlice.reducer;
